import React, { useMemo, useState } from "react";

// ✅ Updated FAQ DATA (Homepage)
const FAQS = [
  {
    question:
      "What is Resolute Corp, and how does it differentiate as a global diversified investment firm?",
    answer:
      "Resolute Corp is a global diversified investment firm offering cross-sector investment strategies across industries, regions, and asset classes. Our approach combines institutional expertise with personalized portfolio design, enabling clients to tap into both global market insights and alternative investment opportunities.",
  },
  {
    question:
      "What services does Resolute Corp provide to family offices and high-net-worth individuals?",
    answer:
      "We provide customized wealth management and advisory services for family offices and HNIs, including portfolio structuring, estate planning, multi-asset allocation, and legacy management. Our family office division ensures long-term stability and generational wealth preservation.",
  },
  {
    question: "How does Resolute Corp approach global investment diversification?",
    answer:
      "Our diversified investment model spreads risk across multiple asset classes, industries, and geographies. Resolute Corp leverages institutional-grade due diligence and data-driven analysis to enhance risk-adjusted returns while maintaining portfolio resilience in volatile markets.",
  },
  {
    question: "What is Resolute Corp’s investment philosophy?",
    answer:
      "Resolute Corp follows a research-driven investment philosophy centered on long-term growth, disciplined risk management, and sustainable value creation. We focus on strategic asset allocation that aligns with our clients’ goals and evolving market dynamics.",
  },
  {
    question:
      "Who are the typical clients of Resolute Corp’s wealth management center?",
    answer:
      "Our wealth management center caters to family offices, corporates, and private investors seeking personalized financial planning and cross-border investment advisory. Clients value our confidentiality, governance-driven process, and global reach.",
  },
  {
    question: "Does Resolute Corp invest in alternative assets?",
    answer:
      "Yes, our alternative investments division identifies opportunities in private equity, real estate, structured credit, and infrastructure projects worldwide. These investments diversify portfolios and enhance long-term value for investors.",
  },
  {
    question: "What makes Resolute Corp a trusted family office wealth advisor?",
    answer:
      "Resolute Corp’s family office wealth advisory combines multigenerational expertise, governance planning, and strategic investment structuring. We partner with families to preserve capital, build legacy portfolios, and manage global holdings seamlessly.",
  },
  {
    question: "How does Resolute Corp ensure risk management across portfolios?",
    answer:
      "We integrate robust risk management frameworks, including stress testing, macroeconomic modeling, and scenario forecasting. This ensures balanced exposure across our clients’ diversified portfolios, safeguarding them from unforeseen market shifts.",
  },
  {
    question: "How does Resolute Corp maintain global presence and local expertise?",
    answer:
      "As a global investment firm, Resolute Corp operates through a network of regional offices and local advisory partners. This ensures on-ground market intelligence, regulatory insight, and access to both developed and emerging opportunities.",
  },
  {
    question:
      "What role does technology play in Resolute Corp’s investment management process?",
    answer:
      "We use AI-driven analytics, data modeling, and digital reporting tools to support smarter decisions and transparent communication. Technology enhances efficiency in our portfolio management and client servicing.",
  },
  {
    question:
      "Can Resolute Corp assist with succession and estate planning for family offices?",
    answer:
      "Yes, our succession planning services help family offices structure wealth transitions effectively. Our team ensures legal, tax, and governance considerations align with both personal and business objectives.",
  },
  {
    question:
      "How does Resolute Corp contribute to sustainable and responsible investing?",
    answer:
      "Resolute Corp integrates ESG (Environmental, Social, Governance) principles into our investment process. We believe responsible investing supports sustainable value creation and aligns with global investors’ ethical priorities.",
  },
  {
    question:
      "What types of clients can benefit from Resolute Corp’s institutional investment strategy?",
    answer:
      "Institutional investors such as pension funds, endowments, and corporations benefit from our bespoke solutions, long-term strategies, and active management approach designed to optimize portfolio performance.",
  },
  {
    question: "How can investors initiate a partnership with Resolute Corp?",
    answer:
      "Prospective clients can connect through our official website or global offices. Our relationship management team schedules a discovery consultation to design a tailored investment strategy aligned with personal or institutional goals.",
  },
  {
    question:
      "What is the long-term vision of Resolute Corp as a global investment leader?",
    answer:
      "Resolute Corp aims to be a global investment leader recognized for its innovation, transparency, and client-first philosophy. Our mission is to build lasting financial partnerships and empower clients to achieve wealth independence across generations.",
  },
];

// ✅ Small icon (no extra library)
const Chevron = ({ open }) => (
  <svg
    className={`h-5 w-5 transition-transform duration-200 ${open ? "rotate-180" : ""}`}
    viewBox="0 0 20 20"
    fill="currentColor"
    aria-hidden="true"
  >
    <path
      fillRule="evenodd"
      d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.24a.75.75 0 01-1.06 0L5.21 8.29a.75.75 0 01.02-1.08z"
      clipRule="evenodd"
    />
  </svg>
);

const Faqs = () => {
  // ✅ default open first item; change to null if you want all closed
  const [openIndex, setOpenIndex] = useState(0);

  const faqs = useMemo(() => FAQS, []);

  const toggle = (idx) => {
    setOpenIndex((prev) => (prev === idx ? null : idx));
  };

  return (
    <section className="max-w-5xl mx-auto px-2 py-12">
      <div className="text-center mb-5">
        <h2 className="text-3xl font-bold text-gray-900">Frequently Asked Questions</h2>
      </div>

      <div className="space-y-2">
        {faqs.map((item, idx) => {
          const isOpen = openIndex === idx;

          return (
            <div
              key={idx}
              className="bg-[#0f4769] rounded-xl border border-gray-200 shadow-sm overflow-hidden"
            >
              <button
                type="button"
                onClick={() => toggle(idx)}
                className="w-full flex items-center justify-between gap-4 px-3 py-4 text-left"
                aria-expanded={isOpen}
              >
                <span className="font-semibold text-white text-sm lg:text-lg">{item.question}</span>
                <span className="text-white">
                  <Chevron open={isOpen} />
                </span>
              </button>

              {/* ✅ Smooth open/close */}
              <div
                className={`grid transition-all duration-300 ease-in-out ${
                  isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                }`}
              >
                <div className="overflow-hidden">
                  <div className="px-5 pb-5 text-sm text-white leading-relaxed text-left">
                    {item.answer}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Faqs;
